<template>
<div class="dboard-card">
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div class="row" v-else>
    <div class="col-lg-12">
      <div class="dboard-card-title">
        Least Performing Transporters
      </div>
      <div class="card-header trans-header" v-if="transList.length">
        <div class="card-col w250">
          NAME
        </div>
        <div class="card-col trans-space-30 w70">
          TOTAL INDENTS
        </div>
        <div class="card-col trans-space-20 w70">
          PLACEMENT DELAY
        </div>
        <div class="card-col  w70">
          TRANSIT DELAY
        </div>
      </div>
      <ol class="dboard-card-panel-list mt-10" v-if="transList.length">
        <li class="dboard-card-panel-section"  v-for="item in transList" :key="item.id">
          <!--
          <div class="dboard-card-section-sectitle primary-text dsplinline">
            {{item.name}}
          </div>
          <div class="dboard-card-section-tertiarynumber tertiary-text dsplinline-right">
            {{Number(item.percentage).toFixed(0)}}% Delayed
          </div>-->
          <div class="card-col trans-row w250">
            {{item.name}}
          </div>
          <div class="card-col trans-row trans-space-30 w70">
            {{item.count}}
          </div>
          <div class="card-col trans-row trans-space-20 placement-delay-text w70">
            {{Number(item.placement_delay_percentage).toFixed(0)}}%
          </div>
          <div class="card-col trans-row transit-delay-text">
            {{Number(item.percentage).toFixed(0)}}%
          </div>
        </li>
      </ol>
      <span class="dboard-card-section-sectitle primary-text" v-else>No Records</span>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    isLoading: {
      type: Boolean,
    },
    count: {
      type: Object,
    },
    transporter: {
      type: Array,
    },
  },
  computed: {
    transList() {
      return this.computePercentage(this.transporter);
    },
  },
  methods: {
    computePercentage(list) {
      list.forEach((item, index) => {
        item.percentage = (item.delayed / item.count) * 100;
        item.placement_delay_percentage = (item.placement_delay / item.count) * 100;
        item.id = index;
      });
      list.sort((a, b) => a.percentage < b.percentage);
      return list.slice(0, 5);
    },
  },
};
</script>
<style lang="scss">
@import "~@common/styles-shipper/settings";
  .trans {
    &-header {
      background-color: transparent;
      margin: 0;
      padding: 0;
      color: #CADCFF;
      font-family:$fontSemibold;
      font-size: 10px;
      line-height: 12px;
    }
    &-space {
      &-30{
        margin-right: 20px;
      }
      &-40{
        margin-right: 30px;
      }
      &-20{
        margin-right: 20px;
      }
    }
  }
  .w {
    &10 {
      width: 20px;
    }
    &20 {
      width: 20px;
    }
  }
  .dboard-card-panel-section {
    .card-col {
      padding: 0;
    }
  }
  .trans-row {
    color: #CADCFF;
    font-family:$fontSemibold;
    font-size: 12px;
  }
  .mt-10 {
    margin-top: 5px;
  }
  .placement-delay-text {
    color: #FA7770;
  }
  .transit-delay-text {
    color: #FFAAA5;
  }
</style>
